global.sq = (parts, ...expressions) =>
  parts
    .reduce((prev, curr, partIndex) => prev + curr + (partIndex < expressions.length ? expressions[partIndex] : ''), '')
    .replace(/\s+/gm, ' ')
    .trim();

export {};
